<script context="module">
    /** static properties so we can have unique ids for each Input */
    export let _id = 1;
</script>

<script lang="ts">
    const generatedId = `vv-checkbox-${_id++}`;
    let _class = "";
    export { _class as class };    
    export let fieldsetClass = "";
    export let labelClass = "";

    export let id = '';
    export let checked = false;
    export let onBeforeInput = (check: boolean, e: Event) => {};
</script>

<fieldset class={fieldsetClass}>
<label for={id || generatedId} class="inline-flex gap-2 cursor-pointer {labelClass}">
    <input id={id || generatedId} class="        
        {$$slots.error ? 'border-vv-red-fire' : ''}
        {_class}
        "
        on:input={(e) => onBeforeInput(checked, e)}
        bind:checked 
        on:input
        on:change
        on:keyup
        on:focus
        on:blur
        type="checkbox"
        {...$$restProps}
    />
    

        <slot></slot>    
    
</label>
{#if $$slots.error}
    <span class="text-sm text-vv-red-fire">
        <slot name="error"></slot>
    </span>
{/if}
</fieldset>